import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { theme } from '../constants/theme'
import { mediaBreakpointGte } from '../utils'
import { StyleProps, createStyles } from '../utils/create-styles'
import { SpaceProps, fontSize, space } from '../utils/styled-system'

const PARAGRAPH_FONT_SIZES: Record<
  ParagraphSize,
  { mobile: number; desktop: number }
> = {
  small: {
    mobile: theme.font.size[6],
    desktop: theme.font.size[6],
  },
  medium: {
    mobile: theme.font.size[5.5],
    desktop: theme.font.size[5],
  },
  large: {
    mobile: theme.font.size[5],
    desktop: theme.font.size[4],
  },
  larger: {
    mobile: theme.font.size[4],
    desktop: theme.font.size[3],
  },
}

export type ParagraphProps = {
  bold?: boolean
  children?: ReactNode
  color?: string
  disabled?: boolean
  noMargin?: boolean
  size?: ParagraphSize
  styles?: StyleProps
  subtle?: boolean
} & SpaceProps

export type ParagraphSize = 'small' | 'medium' | 'large' | 'larger'

export const Paragraph = styled.p<ParagraphProps>((props) => {
  const fontSizes = PARAGRAPH_FONT_SIZES[props.size ?? 'medium']

  return {
    color: props.color,
    ...fontSize({ fontSize: fontSizes.mobile }),
    fontWeight: props.bold ? theme.font.weight.bold : undefined,
    // TODO(rb): change lineHeight to 1.4:
    lineHeight: 1.5,
    marginBottom: props.noMargin ? 0 : 24,
    marginTop: 0,
    maxWidth: 752,
    opacity: props.disabled ? 0.4 : props.subtle ? 0.6 : 0.8,
    ...space(props),
    [mediaBreakpointGte('md')]: {
      ...fontSize({ fontSize: fontSizes.desktop }),
    },
    ...createStyles(props.styles),
  }
})
